var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/ban-types */
import React, { useContext, useEffect, useMemo, } from 'react';
import moment from 'moment';
import 'moment-timezone';
import { Forms, Form, useFormsContext } from '@ally/forms';
import { DATE_PICKER_FORMAT, SERVER_TIMEZONE } from '@ally/date-utils';
import { TransferAccountsContext, useComputedValues } from './useComputedValues';
import { TransferSpeedsContext, TransferSpeedsProvider, useTransferSpeed, } from './useTransferSpeeds';
import { formValuesToTransfer, getMinDeliveryDate } from './utils';
import { RemoteStatus } from './Remote';
import { HolidaysProvider } from './useHolidays';
import useDeliveryDatePrePop from './useDeliveryDatePrePop';
var InnerForm = function (_a) {
    var hostServices = _a.hostServices, children = _a.children;
    var _b = useFormsContext(), formId = _b.formId, setFieldValue = _b.setFieldValue;
    var transferSpeeds = useTransferSpeed(hostServices).transferSpeeds;
    var _c = useComputedValues(), transferType = _c.transferType, frequency = _c.frequency;
    var minDeliveryDate = useMemo(function () {
        return getMinDeliveryDate({
            frequency: frequency,
            transferSpeeds: transferSpeeds,
            transferType: transferType,
        });
    }, [frequency, transferSpeeds, transferType]);
    /**
     * The delivery date pre-pop is handled here instead of in the delivery date
     * input because there is a scenario where we need to skip the first render of
     * the entire form.
     */
    var prePopDate = useDeliveryDatePrePop({ minDeliveryDate: minDeliveryDate });
    useEffect(function () {
        if (prePopDate) {
            setFieldValue('deliveryDate', prePopDate.format(DATE_PICKER_FORMAT), true);
        }
    }, [prePopDate]);
    return React.createElement(Form, { id: formId }, children);
};
var TransferForm = function (_a) {
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, accounts = _a.accounts, hostServices = _a.hostServices, children = _a.children;
    var _b = useContext(TransferSpeedsContext), selectedSpeed = _b.selectedSpeed, withdrawalDateRemote = _b.withdrawalDate;
    var handleSubmit = function (values) {
        var withdrawalDate = withdrawalDateRemote.status === RemoteStatus.Loaded
            ? withdrawalDateRemote.data
            : moment.tz(values.deliveryDate, DATE_PICKER_FORMAT, SERVER_TIMEZONE);
        var meta = {
            transferSpeed: selectedSpeed,
            withdrawalDate: withdrawalDate,
        };
        var transfer = formValuesToTransfer(values, accounts, meta);
        onSubmit({ values: values, meta: meta, transfer: transfer });
    };
    return (React.createElement(TransferAccountsContext.Provider, { value: accounts },
        React.createElement(HolidaysProvider, { hostServices: hostServices },
            React.createElement(Forms, { formId: "transfer-form", initialValues: initialValues, onSubmit: handleSubmit, validateOnChange: false },
                React.createElement(InnerForm, { hostServices: hostServices }, children)))));
};
var TransferFormWithTransferSpeeds = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(TransferSpeedsProvider, null,
        React.createElement(TransferForm, __assign({}, props), children)));
};
export default TransferFormWithTransferSpeeds;
//# sourceMappingURL=TransferForm.js.map